import React from "react";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="spinner-container">
      <img src="/lexiSpinner.png" alt="Loading..." className="spinner" />
    </div>
  );
};

export { Spinner };
